import { render, staticRenderFns } from "./ViewCollaborators.vue?vue&type=template&id=be1a3030&scoped=true"
import script from "./ViewCollaborators.vue?vue&type=script&lang=js"
export * from "./ViewCollaborators.vue?vue&type=script&lang=js"
import style0 from "./ViewCollaborators.vue?vue&type=style&index=0&id=be1a3030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a3030",
  null
  
)

export default component.exports